// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataFieldTypeEnum
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DataFieldTypeEnum = /*#__PURE__*/function (DataFieldTypeEnum) {
  DataFieldTypeEnum[DataFieldTypeEnum["STRING"] = 0] = "STRING";
  DataFieldTypeEnum[DataFieldTypeEnum["TEXT"] = 1] = "TEXT";
  DataFieldTypeEnum[DataFieldTypeEnum["DECIMAL"] = 2] = "DECIMAL";
  DataFieldTypeEnum[DataFieldTypeEnum["DATETIME"] = 3] = "DATETIME";
  DataFieldTypeEnum[DataFieldTypeEnum["DATE"] = 4] = "DATE";
  DataFieldTypeEnum[DataFieldTypeEnum["BOOLEAN"] = 5] = "BOOLEAN";
  DataFieldTypeEnum[DataFieldTypeEnum["REFERENCE"] = 6] = "REFERENCE";
  DataFieldTypeEnum[DataFieldTypeEnum["BINARY"] = 7] = "BINARY";
  DataFieldTypeEnum[DataFieldTypeEnum["DYNAMIC"] = 8] = "DYNAMIC";
  return DataFieldTypeEnum;
}({});
(function (_DataFieldTypeEnum) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DataFieldTypeEnum[enumVal] != null ? enumVal : undefined : DataFieldTypeEnum[enumVal];
  }
  _DataFieldTypeEnum.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DataFieldTypeEnum.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DataFieldTypeEnum.indexOf = indexOf;
})(DataFieldTypeEnum || (DataFieldTypeEnum = {}));
//# sourceMappingURL=DataFieldTypeEnum.js.map
